import { fileDownloadClient, pdfClient } from '../../api/clients';
import generatePBOM from './generate-birth-certificate/generate-birth-certificate';
import fetchReadyPBOM from './fetch-ready-pbom/fetch-ready-pbom';
import generateBirthCertificate from './generate-pbom-legacy/generate-pbom-legacy';

const birthCertificateService = {
  // TODO: change pdf client to file download service for non legacy
  generateBirthCertificate: generatePBOM(fileDownloadClient),
  generateBirthCertificateLegacy: generateBirthCertificate(pdfClient),
  fetchReadyPBOM: fetchReadyPBOM(fileDownloadClient),
};

export default birthCertificateService;
